import PropTypes from 'prop-types'
import {StarIcon} from '../../icons'

export const StarRating = ({
  score,
  size = '12px',
  colorActive = 'mld.primary.300',
  colorInactive = 'grey.500',
  mr = 'xxs',
}) => (
  <>
    {[...Array(5).keys()].map((value) => (
      <StarIcon
        data-testid="star-icon"
        key={value}
        color={score > value ? colorActive : colorInactive}
        h={size}
        w={size}
        mr={mr}
      />
    ))}
  </>
)

StarRating.propTypes = {
  score: PropTypes.number.isRequired,
  size: PropTypes.string,
  colorActive: PropTypes.string,
  colorInactive: PropTypes.string,
  mr: PropTypes.string,
}

StarRating.defaultProps = {
  size: '12px',
  colorActive: 'mld.primary.300',
  colorInactive: 'grey.500',
  mr: 'xxs',
}

export default StarRating
